export default __webpack_public_path__ + "static/column-with-negative-values-de034f22e8148e77a90ece0246d79ce0.png";